import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

   export const getData = createAsyncThunk('appClientCreditCards/getData', async (params) => {
      const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummaryClientCreditCards', params, {mode:'cors'})
         return {
            params,
            data: response.data,
            allData: response.data.allData
         }
   })

   export const getCreditCardsData = createAsyncThunk('appClientCreditCards/getCreditCardsData', async (GetCCDetails) => {
      const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummaryClientCreditCards', GetCCDetails, {mode:'cors'})
         return response.data
   })
   export const StripeKey = createAsyncThunk('appCardtransactions/StripeKey', async (GetCCDetails) => {
      const response = await axios.post('https://api.zasway.com:8443/Configuration/GetStripeKeyLive', GetCCDetails, {mode:'cors'})
      return response.data 
    })
   export const addCreditCards = createAsyncThunk('appClientCreditCards/addCreditCards', async (CreditCard) => {
      const response = await axios.post('https://api.zasway.com:8443/Client/CreateCard', CreditCard, {mode:'cors'})
         return response
   })

   export const editCreditCards  = createAsyncThunk('appClientCreditCards/editCreditCards', async (CreditCard) => {
      const response = await axios.post('https://api.zasway.com:8443/Client/UpdateCard', CreditCard, {mode:'cors'})
         return response
   })
   export const DefaultCard = createAsyncThunk('appClientCreditCards/DefaultCard', async (params) => {
       
      const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/MakeClientCardDefault', params, {mode:'cors'})
       
         return response
   })
   
   export const getCreditCardEditData = createAsyncThunk('appClientCreditCards/getCreditCardEditData', async (params) => {
       
      const response = await axios.post('https://api.zasway.com:8443/Client/GetTableSummaryClientCreditCards', params, {mode:'cors'})
       
         return response
   })

   export const deleteCreditCard = createAsyncThunk('appClientCreditCards/deleteCreditCard', async (id, { dispatch, getState }) => {
      const response = await axios.post('https://api.zasway.com:8443/Client/DeleteCard', id, {mode:'cors'})
         await dispatch(getData(getState().params))
         
            return response
   })

   export const appClientCreditCardsSlice = createSlice({
      name: 'appClientCreditCards',
      initialState: {
         data: [],
         allData: [],
         params: {},
         creditCardEditData: []
      },
      reducers: {},
      extraReducers: builder => {
         builder

         .addCase(getData.fulfilled, (state, action) => {
            state.data = action.payload.data
            state.allData = action.payload.allData
            state.params = action.payload.params
         })

         .addCase(getCreditCardsData.fulfilled, (state, action) => {
            state.allData = action.payload.allData
            state.data = action.payload.data
         })

         .addCase(getCreditCardEditData.fulfilled, (state, action) => {
            state.creditCardEditData = action.payload.data
         })
      }
   })
  
export default appClientCreditCardsSlice.reducer